module.exports = __webpack_public_path__ + "img/3.69d9264b.png";